// @flow
import { canChooseDeliveryMethodSelector } from '../DeliveryMethod/selectors';
import { CommonActions } from '@react-navigation/native';
import { hasCustomPaymentMeanSelector } from '../../Customer/selectors';
import { resetDeliveryMethod, checkPremiumEligibilitySaga } from '../DeliveryMethod';
import { setDeliveryAddress } from './actions';
import { setLoading } from '../../LoadingStatus';
import { takeEvery, put, call, select } from 'redux-saga/effects';
import config from '../../../config';
import I18n from '../../../lib/i18n';
import Navigation from '../../../lib/navigation';
import Toast from '../../../lib/toastService';
import type { DeliveryAddressActionType } from './actions';
import WizzeeLog from '../../../lib/wizzeeLog';

export function* confirmDeliverySaga(action: DeliveryAddressActionType): Generator<*, *, *> {
  if (action.type !== 'CONFIRM_DELIVERY_ADDRESS') return;

  try {
    yield put(setLoading('confirmDeliveryAddress', true));
    yield put(resetDeliveryMethod());
    const { deliveryAddress } = action.payload;
    yield put(setDeliveryAddress(deliveryAddress));

    let canChooseDeliveryMethod = config.canChooseDeliveryMethod;
    if (config.canChooseDeliveryMethod) {
      yield call(checkPremiumEligibilitySaga);
      canChooseDeliveryMethod = yield select(canChooseDeliveryMethodSelector);
    }
    const hasPaymentMean = yield select(hasCustomPaymentMeanSelector);

    if (canChooseDeliveryMethod) {
      yield call(Navigation.dispatch, CommonActions.navigate({ name: 'deliveryMethod' }));
    } else {
      yield call(
        Navigation.dispatch,
        CommonActions.navigate({
          name: config.askPersonalInformationDuringOrderSim
            ? hasPaymentMean
              ? 'confirmPlan'
              : 'registerPaymentDetails'
            : 'deliveryContact',
        })
      );
    }
  } catch (e) {
    if (e && e.message === 'INVALID_COUNTRY') {
      Toast.showError(I18n.t('error.validation.wrongCountry', { country: I18n.t('countries.' + config.country) }));
    } else {
      WizzeeLog.warn('[saga] confirmDeliverySaga', e);
      yield call(Navigation.dispatch, CommonActions.navigate({ name: 'deliveryMethod' }));
    }
  } finally {
    yield put(setLoading('confirmDeliveryAddress', false));
  }
}

export default function*(): Generator<*, *, *> {
  yield* [takeEvery('CONFIRM_DELIVERY_ADDRESS', confirmDeliverySaga)];
}
